// Shared client config (refactor phase 1).
export const API_BASE = window.location.hostname === 'localhost'
  ? 'http://localhost:5002'
  : '';
